import script from "./RestorePassword.vue?vue&type=script&setup=true&lang=js"
export * from "./RestorePassword.vue?vue&type=script&setup=true&lang=js"

import "./RestorePassword.vue?vue&type=style&index=0&id=d16a4bcc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d16a4bcc"]])

export default __exports__